import React from "react";
import { pageTitle } from "../../helpers/PageTitle";
import { BASE_URL } from "../../helpers/api";
import Section from "../Section";
import BannerSectionStyle4 from "../Section/BannerSection/BannerSectionStyle4";
import BannerSectionStyle5 from "../Section/BannerSection/BannerSectionStyle5";
import TeamSectionStyle2 from "../Section/TeamSection/TeamSectionStyle2";
import Breadcrumb from '../Breadcrumb';


const doctorsData = await fetch(`${BASE_URL}/doctors/doc`);

const teamData = await doctorsData.json();
export default function Doctors() {
  pageTitle("Doctors");

  return (
    <>
      <BannerSectionStyle5
        bgUrl="/images/doctors/banner_bg.svg"
        imgUrl="/images/doctors/doctorsimg.jpg"
        title="Introduce You to <br />Our Experts"
        subTitle="The list of certified doctors with years of <br />professional experience"
      />

          {/* <Section topMd={50} bottomMd={36} bottomLg={10}>
              <Breadcrumb title="Meet Our Expert" />
            </Section> */}

            <Section topMd={50}  bottomLg={10}>
              <div className="container">
                <h2>Meet Our Experts</h2>
              </div>
            </Section>
      
      <Section topMd={0} bottomMd={10} bottomLg={0} bottomXl={10}>
        <TeamSectionStyle2 data={teamData} />
      </Section>
      {/* <Section className="cs_footer_margin_0">
        <BannerSectionStyle4
          bgUrl="images/doctors/doctorsimg3.webp"
          title="Don’t Let Your Health <br />Take a Backseat!"
          subTitle="Schedule an appointment with one of our experienced <br />medical professionals today!"
        />
      </Section> */}
    </>
  );
}